import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { worksList } from "@/mocks/works";

export default function HomeWorksSection() {
  const featured = worksList[0];
  const items = worksList.slice(1, 5);

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Filmography"
        title="影视作品推荐"
        description="从九十年代的银幕初亮相，到即将上映的新片，这里按年份整理了最值得回看的几部作品。"
        action={
          <Link
            to="/works"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            全部作品
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.15fr_1fr]">
        <Link
          to={`/works/${featured.id}`}
          className="group relative block overflow-hidden rounded-lg bg-foreground-950"
        >
          <div className="h-[420px] w-full overflow-hidden sm:h-[520px] lg:h-full lg:min-h-[540px]">
            <img
              src={featured.cover}
              alt={`${featured.title} 海报 - 张柏芝影视作品`}
              title={`${featured.title} - 张柏芝影视作品`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/30 to-foreground-950/10"></div>
          <div className="absolute left-5 top-5 flex items-center gap-2">
            <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] text-background-50">
              {featured.highlight}
            </span>
            <span className="rounded-full bg-background-50/15 px-3 py-1 text-[11px] text-background-100 backdrop-blur">
              {featured.type} · {featured.year}
            </span>
          </div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
            <p className="text-[11px] tracking-[0.24em] text-background-300">
              {featured.enTitle ? featured.enTitle.toUpperCase() : "FILMOGRAPHY"}
            </p>
            <h3 className="mt-2 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
              {featured.title}
            </h3>
            <p className="mt-2 text-xs text-background-200">
              导演 {featured.director} · 饰演 {featured.role}
            </p>
            <p className="mt-3 line-clamp-2 max-w-lg text-[13px] leading-6 text-background-200">
              {featured.synopsis}
            </p>
            <span className="mt-5 inline-flex items-center gap-2 rounded-md bg-background-50 px-4 py-2 text-xs text-foreground-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              查看作品资料
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </span>
          </div>
        </Link>

        <div className="grid grid-cols-2 gap-4 sm:gap-5">
          {items.map((item) => (
            <WorkCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}